import { Component, OnInit } from '@angular/core';
import { SsoAuthService } from 'src/app/ecan/sso-auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  public isAuthenticated: boolean;

  constructor(
    public authService: SsoAuthService,
    private router: Router) {

  }

  ngOnInit() {
    this.isAuthenticated = this.authService.isAuthenticated();
  }

  public login() {
    this.authService.login(null);
  }

  public continue() {
    this.router.navigate(['/home']);
  }
}
